/**
 * Fix GB (2026-10-14): "Agregar también un filtro múltiple por cargos (Ing Residente,
 * Proyectista, Jefe de Compras, etc). Para poder generar también las liquidaciones de lo que
 * es CEN Operativamente" (CEN). Desplegable con casillas, igual que el de empleados.
 */
import { useState, useRef, useEffect } from "react";
import { ChevronDown, X, Check } from "lucide-react";

export default function SelectorCargos({ cargos, value, onChange, testid = "selector-cargos", placeholder = "Todos los cargos" }) {
  const [abierto, setAbierto] = useState(false);
  const caja = useRef(null);
  const elegidos = value || [];

  useEffect(() => {
    if (!abierto) return;
    const fuera = (e) => { if (caja.current && !caja.current.contains(e.target)) setAbierto(false); };
    document.addEventListener("mousedown", fuera);
    return () => document.removeEventListener("mousedown", fuera);
  }, [abierto]);

  const alternar = (c) => onChange(elegidos.includes(c) ? elegidos.filter(x => x !== c) : [...elegidos, c]);
  const etiqueta = elegidos.length === 0 ? placeholder : elegidos.length === 1 ? elegidos[0] : `${elegidos.length} cargos seleccionados`;

  return (
    <div className="relative" ref={caja} data-testid={testid}>
      <button type="button" onClick={() => setAbierto(a => !a)}
        className="w-full border border-gray-300 rounded-lg px-2 py-1.5 text-xs bg-white flex items-center justify-between gap-2 hover:border-[#2E6DA4] focus:ring-2 focus:ring-[#2E6DA4]/20"
        data-testid={`${testid}-btn`}>
        <span className={elegidos.length ? "text-gray-900 truncate" : "text-gray-400"}>{etiqueta}</span>
        <span className="flex items-center gap-1 flex-shrink-0">
          {elegidos.length > 0 && (
            <span onClick={e => { e.stopPropagation(); onChange([]); }} className="text-gray-400 hover:text-red-500"
              title="Quitar la selección" data-testid={`${testid}-limpiar`}><X size={12} /></span>
          )}
          <ChevronDown size={14} className="text-gray-400" />
        </span>
      </button>
      {abierto && (
        <div className="absolute z-30 mt-1 w-full min-w-[200px] bg-white border border-gray-200 rounded-xl shadow-lg max-h-64 overflow-y-auto py-1" data-testid={`${testid}-lista`}>
          {(cargos || []).length === 0 && <p className="px-3 py-2 text-xs text-gray-400">No hay cargos cargados</p>}
          {(cargos || []).map(c => (
            <button type="button" key={c} onClick={() => alternar(c)}
              className="w-full flex items-center gap-2 px-3 py-1.5 text-xs text-left hover:bg-gray-50" data-testid={`${testid}-op-${c}`}>
              <span className={`w-4 h-4 rounded border flex items-center justify-center flex-shrink-0 ${elegidos.includes(c) ? "bg-[#2E6DA4] border-[#2E6DA4] text-white" : "border-gray-300"}`}>
                {elegidos.includes(c) && <Check size={11} />}
              </span>
              <span className="truncate">{c}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
